export default __webpack_public_path__ + "static/media/IMG-20240729-WA0005.32b2fbae.jpg";